var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('app-welcome'),_c('app-actu'),_c('app-testimony'),_c('form-contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }